/* eslint-disable max-len */

/* App Config */
export const appConfig = {
  API_BASE_URL: process.env.REACT_APP_ACCOUNT_SERVICE_API_URL?.slice(0, -1) || 'https://api.kickfin.dev',
  AVATAR: {
    BASE_URL: process.env.REACT_APP_AVATAR_URL,
    MAX_FILE_SIZE: 20000000, // Max file size in bytes
    RESIZE_WIDTH: 500, // Resize width in pixles (px)
    RESIZE_HEIGHT: 500, // Resize height in pixles (px)
  },
  LINKS: {
    CHIME: 'https://www.chime.com',
    KICKFIN_REFERRALS: 'https://kickfin.com/partners/make-a-referral/?utm_medium=app&utm_source=login+screen',
    KICKFIN_DEMO: 'https://kickfin.com/demo/',
    PRIVACY_POLICY: 'https://www.kickfin.com/privacy-policy/',
    SUPPORT: 'https://www.kickfin.com/contact-us/',
    TERMS_OF_USE: '/payment_recipient_terms_of_use',
    VISTA_PRINT:
      'https://www.vistaprint.com/studio/?key=PRD-IYXT1T3V&productVersion=15&locale=en-us&selectedOptions=%7B%22Product+Orientation%22%3A%22Horizontal%22%2C%22Shape%22%3A%22Standard%22%7D&fullBleedElected=true&mpvId=standardBusinessCards&qty=100',
  },
  TIP: {
    MIN: 1, // Minimum tip value allowed in cents ($00.01)
    MAX: 600000, // Maximum tip value allowed in cents ($600.00)
  },
  DATE_RANGE: {
    MAX_DAYS_YEAR: 366, // Maximum days allowed for a year (is default for date range picker)
    MAX_DAYS_3_MONTHS: 92, // Maximum days for 3 months (used for ledger)
  },
  TIP_ACCEPTANCE: {
    ALLOW_HOLDBACKS: false, // !!! IMPORTANT !!! IF HOLDBACKS ARE ALLOWED IN THIS TIP ACCEPTANCE FLOW, ONLY CHANGE THIS VALUE.
  },
  VERSIONS: {
    TERMS_OF_SERVICE: '01182023',
    PRIVACY_POLICY: '12312022',
  },
};
